module.exports = __webpack_public_path__ + "img/diamond.8cfc370e.svg";